import { CrossIcon } from "../../Icons";
import KAIlogo from "../../../assets/svgs/KAI.svg";

export default function ChatHeader({ onClose }: { onClose: () => void }) {
  return (
    <div className="bg-white border-b border-gray-200 flex justify-between items-center p-4 shadow-sm">
      <div className="flex items-center gap-3">
        {/* Logo + Title Block */}
        <img src={KAIlogo} alt="KAI Logo" className="w-8 h-8 object-contain" />
        <div className="flex flex-col">
          <h2 className="text-lg font-semibold text-gray-800 leading-tight">
            KAI Assistant
          </h2>
          <p className="text-sm text-gray-500 -mt-0.5">
            Your smart logistics coordinator
          </p>
        </div>
      </div>

      {/* Close Button */}
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-red-400 hover:scale-90 transition-all duration-200 text-2xl leading-none"
      >
        <CrossIcon className="size-6" />
      </button>
    </div>
  );
}
